import { useEffect } from "react";
import HubspotForm from "react-hubspot-form";
import DataLayerEventTypes from "constants/data-layer-event-types";
import { fireGtmEvent } from "client/services/gtm-service/gtm-service";
import { HUBSPOT_FORM_SUBMIT_CLICKED, HUBSPOT_FORM_READY } from "constants/bigbrain-event-types";
import MondayLoaderComponent from "components/core/loader/monday-loader-component";
import { trackEvent } from "services/bigbrain-service";
import { PORTAL_ID } from "client/services/hubspot-service/contact-form-config";
import { generateHiddenData } from "client/services/hubspot-service/hubspot-service";
import { withAbTests } from "contexts/ab-tests-context";
import { withGenericConfig } from "contexts/generic-config-context";
import jquery from "jquery";
import { HUBSPOT_API_COMPANY_SIZE } from "client/services/hubspot-service/hubspot-constants";
import mapValues from "lodash/mapValues";
import keyBy from "lodash/keyBy";
import * as Sentry from "@sentry/nextjs";
import { StyledContactSalesHubspotFormComponent } from "./contact-sales-hubspot-form-component.scss";

const ContactSalesHubspotFormComponent = (props) => {
  const { formId, formMinHeight, withPrivacyNotice, source, abTests, cookies, cloudfrontViewerCountry } = props;

  const renderLoadingState = () => (
    <div className="monday-loader-wrapper">
      <MondayLoaderComponent />
    </div>
  );

  useEffect(() => {
    // needed for Hubspot form to send submit callback
    window.jQuery = window.jQuery || jquery;
  }, []);

  const onReady = () => {
    // We attach visitor_id as hidden field so we can track from
    // which LPs users make the Hubspot form submissions
    const hiddenData = generateHiddenData({
      withPrivacyNotice,
      source,
      abTests,
      cookies,
      cloudfrontViewerCountry
    });

    hiddenData.forEach((data) => {
      const hiddenField = document.querySelector(`input[name="${data.name}"]`);
      if (hiddenField) {
        hiddenField.value = data.value;
      }
    });

    trackEvent(HUBSPOT_FORM_READY, { kind: formId });
  };

  const onSubmit = (formData) => {
    const companySize = formData?.find((field) => field.name === HUBSPOT_API_COMPANY_SIZE)?.value;
    fireGtmEvent(DataLayerEventTypes.HUBSPOT_FORM_SUBMITTED, { formId });

    let data;
    try {
      data = {
        ...mapValues(keyBy(formData, "name"), "value"),
        leadsource: source
      };
    } catch (e) {
      Sentry.captureException(e);
    }

    trackEvent(HUBSPOT_FORM_SUBMIT_CLICKED, {
      kind: formId,
      info1: companySize,
      data
    });
  };

  return (
    <StyledContactSalesHubspotFormComponent
      className="contact-sales-hubspot-form-component"
      style={{ minHeight: formMinHeight }}
    >
      <HubspotForm
        portalId={PORTAL_ID}
        formId={formId}
        loading={renderLoadingState()}
        onReady={onReady}
        cssClass="hbspt-form"
        onSubmit={onSubmit}
        translations={{ en: { required: "Required" } }}
      />
    </StyledContactSalesHubspotFormComponent>
  );
};

export default withAbTests(withGenericConfig(ContactSalesHubspotFormComponent));
